import styled from "styled-components";
import { Radius, Spacing } from "components/designV2/constants";
import { mediaMax } from "components/designV2/breakpoints";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const WorkerDocumentListTitle = styled.p`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
`;

export const WorkerDocumentList = styled.ul`
  list-style: none;
  padding: 0;
`;

export const WorkerDocumentListItem = styled.li`
  margin-bottom: ${Spacing.lg}px;
`;

export const WorkerDocumentListItemTitle = styled.p`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue1};
  margin-bottom: ${Spacing.sm}px;
`;

export const WorkerDocumentFileSize = styled.span`
  color: inherit;
`;

export const WorkerDocumentNoFiles = styled.p`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue1};
`;

export const WorkerDocumentDownloadWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const WorkerDocumentCardList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.sm}px;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const WorkerDocumentCardItem = styled.li`
  align-items: center;
  background: ${ColorV2.White};
  border-radius: ${Radius.lg}px;
  display: flex;
  gap: ${Spacing.md}px;
  justify-content: space-between;
  padding: ${Spacing.md}px ${Spacing.lg}px;

  ${mediaMax.mobile} {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const WorkerDocumentCardTitle = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const WorkerDocumentCardButtonWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
`;

export const WorkerDocumentDownload = styled.a`
  ${TypographyV2.s1}
  align-items: center;
  background-color: ${ColorV2.SimflexityGreen};
  border-radius: 2px;
  color: ${ColorV2.White};
  cursor: pointer;
  display: flex;
  gap: ${Spacing.sm}px;
  padding: ${Spacing.sm}px;
  text-decoration: none;

  &:hover {
    opacity: 0.6;
  }
`;
